



























































































































































































import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';

import moment from 'moment';
import { partyWorkDaysStore } from '@/libs/party-work-days/+state/store';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudAction, CrudReponse, CrudResponseAction } from '@/libs/core/+state/models/crud-action';
import { ApplicationUserModel, PartyWorkDayModel } from '@/libs/Api';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import WorkTaskDialog from '@/libs/work-tasks/components/WorkTaskDialog.vue';
import { applicationUserStore } from '@/libs/user-settings/+state/store';

import InfiniteLoading from 'vue-infinite-loading';
import { CrudQueryPaging } from '@/libs/core/+state/models/crud-query-paging';

@Component({
    components: {
        WorkTaskDialog,
        InfiniteLoading
    }
})
export default class DashboardWorkTaskColumn extends Page {

    @Ref() dialog!: WorkTaskDialog;
    user: ApplicationUserModel = applicationUserStore.useGetter(CrudGetter.Detail);
    items: PartyWorkDayModel[] = [];
    subscribtion: any = null;
    date = moment().toDate();

    @Prop() tenantId!: string;

    get waitingItems() : PartyWorkDayModel[] {
        return this.items.filter(x => x.isDone == false);
    }

    get doneItems() : PartyWorkDayModel[] {
        return this.items.filter(x => x.isDone == true);
    }

    mounted () {
        const self = this;
        this.subscribtion = this.$store.subscribe((mutation, _state) => {
			if (mutation.type === partyWorkDaysStore.getActionName(CrudResponseAction.PartialUpdateSuccess)) {
				self.items.forEach((x) => {
					if (x.id == mutation.payload?.item?.id) {
						self.items.splice(self.items.indexOf(x), 1, mutation.payload!.item);
					}
					else if (x.id == mutation.payload?.itemBasic?.id) {
						self.items.splice(self.items.indexOf(x), 1, mutation.payload!.itemBasic);
					}
				});
			}
			else if (mutation.type === partyWorkDaysStore.getActionName(CrudResponseAction.UpdateSuccess)) {
				self.items.forEach((x) => {
					if (x.id == mutation.payload?.item?.id) {
						self.items.splice(self.items.indexOf(x), 1, mutation.payload!.item);
					}
					else if (x.id == mutation.payload?.itemBasic?.id) {
						self.items.splice(self.items.indexOf(x), 1, mutation.payload!.itemBasic);
					}
				});
			}
			else if (mutation.type === partyWorkDaysStore.getActionName(CrudResponseAction.DeleteSuccess)) {
				self.items.forEach((x) => {
					if (x.id == mutation.payload?.item?.id) {
						self.items.splice(self.items.indexOf(x), 1);
					}
					else if (x.id == mutation.payload?.itemBasic?.id) {
						self.items.splice(self.items.indexOf(x), 1);
					}
				});
			}
        })
    }

    destroyed () {
        if (typeof this.subscribtion == "function")
            this.subscribtion();
    }


    loadItems ($state : any = null) {
        const key = "DashboardItems";
        const filterPredicates = [
            { field: "day", op: "gte", comparand: moment(this.date).startOf("day").toDate() },
            { field: "day", op: "lte", comparand: moment(this.date).endOf("day").toDate() }
        ] as any;
        partyWorkDaysStore.dispatch(CrudAction.GetAllBasic, createCrudQueryPayload<PartyWorkDayModel>([
            { field: "isDone", index: 1, order: "asc" },
            { field: "party.lastName", index: 2, order: "asc" }
        ], filterPredicates, {
            pageIndex: Math.floor(this.items.length / 20) + 1,
            pageSize: 20
        } as CrudQueryPaging, false, key))
        this.subscribe(partyWorkDaysStore, CrudReponse.GetAllBasic, key).then((e: PartyWorkDayModel[]) => {
            var loadedNewItems = e.filter(x => !this.items.any(p => x.id == p.id)).length > 0;
            this.items = [
                ...this.items.filter(x => !e.any(p => x.id == p.id)),
                ...e
            ];
            const dataStats = partyWorkDaysStore.useGetter(CrudGetter.DataStatsBasic, key);
            if ($state) {
                if (this.items.length < dataStats.rowCount && loadedNewItems)
                    $state.loaded();
                else
                    $state.complete();
            }
        }).catch(() => {
            if ($state)
                $state.complete();
        });
    }

    open (item: PartyWorkDayModel) {
        this.dialog.open(item.id!, item!.partyId!, item.day!);
    }

    goToLocation(item: PartyWorkDayModel) {
        const n: Array<string | null> = [ item.party?.street ?? null, item.party?.city ?? null, item.party?.zip ?? null ];
        const address = n.filter(x => x != null && x.length > 0).join(", ");
        window.open('https://google.com/maps/place/' + address, '_blank');
    }

    getInitials (v: string) {
        let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');

        let initials: any = [...v.matchAll(rgx)] || [];

        initials = (
            (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
        ).toUpperCase();

        return initials;
    }

}
